/* PureState shared CTA */
if (!window.psCta) window.psCta = (function () {
 var seen = null, pending = false, doc = document, q = function (s) { return doc.querySelector(s); };
 function getForm() { return q('product-info form[data-type="add-to-cart-form"]'); }
 function scrollTo(t) {
  var el = null;
  try { el = t && q(t); } catch (e) {}
  if (!el) return false;
  el.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  if (t[0] === '#') history.replaceState(null, '', t);
  var f = getForm(), r = f && f.querySelector('input[type="radio"]:checked');
  if (r) r.focus({ preventScroll: true });
  return true;
 }
 function mirror() {
  var f = getForm(), b = f && f.querySelector('[type="submit"]');
  if (!b || b === seen || !window.MutationObserver) return;
  seen = b;
  var sync = function () {
   var busy = b.disabled || b.getAttribute('aria-disabled') === 'true' || b.classList.contains('loading');
   doc.querySelectorAll('[data-ps-cta-action^="add_"]').forEach(function (c) {
    c.classList.toggle('loading', busy);
    c.setAttribute('aria-disabled', busy ? 'true' : 'false');
   });
  };
  new MutationObserver(sync).observe(b, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
  sync();
 }
 function submit(form, checkout) {
  if (checkout && !pending && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
   pending = true;
   var off = subscribe(PUB_SUB_EVENTS.cartUpdate, function (d) {
    if (d && d.source && d.source !== 'product-form') return;
    pending = false;
    if (typeof off === 'function') off();
    setTimeout(function () { location.href = '/checkout'; }, 300);
   });
  }
  if (form.requestSubmit) form.requestSubmit();
  else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
 }
 doc.addEventListener('click', function (evt) {
  var el = evt.target.closest && evt.target.closest('[data-ps-cta-action]');
  if (!el) return;
  var a = el.getAttribute('data-ps-cta-action'), form = getForm();
  if (a === 'scroll_to_buybox') {
   if (scrollTo(el.getAttribute('data-ps-cta-target') || el.getAttribute('href') || '#buy-box')) evt.preventDefault();
  } else if (a === 'add_to_cart' || a === 'add_and_checkout') {
   if (!form) { if (el.tagName !== 'A' && scrollTo('#buy-box')) evt.preventDefault(); return; }
   evt.preventDefault();
   if (el.getAttribute('aria-disabled') === 'true') return;
   mirror();
   submit(form, a === 'add_and_checkout');
  }
 });
 if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', mirror); else mirror();
 return { getForm: getForm, scrollTo: scrollTo, mirror: mirror };
})();
